<template>
    <div class="pageBox">
        <PageComponent publicTemplateName="访问后未填报员工信息单位的应训人员" :publicStatus="2200"></PageComponent>
    </div>
</template>

<script>
import PageComponent from "./PageComponent"
export default {
    components: {PageComponent},
    data() {
        return{
            
        }
    },
    methods: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
}
</script>

<style lang="stylus" scoped>
    
</style>